import { TruncatedElementWithTooltip } from 'components/common/TruncatedElementWithTooltip/TruncatedElementWithTooltip';
import { SetupFrameInformation } from '../../Setup.types';

const UploadedByRenderer = ({ data }: { data?: SetupFrameInformation }): React.ReactElement | null => {
  if (!data) return null;

  return (
    <TruncatedElementWithTooltip tooltip={data.uploadUserName}>
      {(ref) => (
        <span ref={ref} className="block max-w-[210px] truncate">
          {data.uploadUserName}
        </span>
      )}
    </TruncatedElementWithTooltip>
  );
};

export default UploadedByRenderer;
